import {
  BANK_BRANCHES,
  BANK_CODES,
  BANK_NAMES,
  type BankId,
} from '@energy-retailer/constants';
import get from 'lodash/get';

export const validateBsb = (bsb: string): boolean => {
  const [bankNumber = '', branchNumber = ''] = bsb.split('-');
  const bankCode = get(BANK_CODES, bankNumber) as BankId;
  const bankId = BANK_NAMES[bankCode] as string;

  // Invalid - could not map bank code to bank name/id.
  if (!bankId) {
    return false;
  }

  const bankBranches = get(BANK_BRANCHES, bankNumber) as string[] | undefined;

  // could not find list of branches for bank number.
  if (!bankBranches) {
    return false;
  }

  // could not find branch number in associated bank branch list.
  if (!bankBranches.includes(branchNumber)) {
    return false;
  }

  return true;
};
